module.exports = __webpack_public_path__ + "img/reminder.c50ed14f.svg";